import { render, staticRenderFns } from "./ResumeOverview.vue?vue&type=template&id=77bba816&"
import script from "./ResumeOverview.vue?vue&type=script&lang=js&"
export * from "./ResumeOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports